import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "navLabel", "navLink"]

  connect() {
    this.collapsed = this.readState()
    this.applyState()
  }

  toggle() {
    this.collapsed = !this.collapsed
    this.writeState()
    this.applyState()
  }

  applyState() {
    if (this.collapsed) {
      this.sidebarTarget.classList.remove("w-64")
      this.sidebarTarget.classList.add("w-20")
      this.navLabelTargets.forEach((label) => {
        label.classList.add("hidden")
      })
      this.navLinkTargets.forEach((link) => {
        link.classList.remove("justify-start", "px-3")
        link.classList.add("justify-center", "px-2")
      })
    } else {
      this.sidebarTarget.classList.remove("w-20")
      this.sidebarTarget.classList.add("w-64")
      this.navLabelTargets.forEach((label) => {
        label.classList.remove("hidden")
      })
      this.navLinkTargets.forEach((link) => {
        link.classList.remove("justify-center", "px-2")
        link.classList.add("justify-start", "px-3")
      })
    }
  }

  readState() {
    try {
      return JSON.parse(window.localStorage.getItem(SIDEBAR_KEY)) === true
    } catch (error) {
      console.warn("Unable to read sidebar state", error)
      return false
    }
  }

  writeState() {
    try {
      window.localStorage.setItem(SIDEBAR_KEY, JSON.stringify(this.collapsed))
    } catch (error) {
      console.warn("Unable to persist sidebar state", error)
    }
  }
}

const SIDEBAR_KEY = "adminSidebarCollapsed"
